const columns = [
  { name: "Capítulo", value: "chapterName", filter: true, order: false },
  { name: "Objetivo", value: "learningObjectiveName", filter: true, order: false },
  { name: "Média no quiz", value: "quizAverage", filter: false, order: false },
  { name: "Turma", value: "classroomName", filter: false },
]

export { columns };
